import { useEffect } from "react";
import { useLocation } from "react-router";

const useLivevoxCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const widget = document.querySelector(
        "iframe[name*='__zoid__web_widget__']"
      );
      if (widget) {
        widget.remove();
      }
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [location.pathname]);
};

export default useLivevoxCleanup;
